import save from '../Services/save'

export default (jobs, subcontractor, projectId, date) => (dispatch) => {

  dispatch(save(jobs, subcontractor, projectId, date))

}
